import React, {useEffect, useState} from 'react';
import ProgramOutlineView from "../../views/ver_24.10/ProgramOutline/ProgramOutline.view";
import {useHistory, useParams} from "react-router-dom";
import {CHAT_TYPE, PBDQ3_PROGRAM_STATE} from "../../utils/constants";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {
    fetchProgramOutlineService, removeModuleProgramService,
    removeUnitProgramService,
    updateProgramStatusService
} from "../../services/program.service";
import {toastWarning} from "../../utils/utils";

const ProgramOutlinePage = () => {
    const { programId } = useParams();

    const history = useHistory();
    const [chatHistory, setChatHistory] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [programData, setProgramData] = useState({});
    const [unitsData, setUnitsData] = useState([]);
    const [modulesData, setModulesData] = useState([]);

    useEffect(() => {
        setShowLoader(true);
        fetchProgramOutline().then(resp => setShowLoader(false)).catch(err => setShowLoader(false));
    }, []);

    const fetchProgramOutline = async () => {
        setShowLoader(true);
        if (programId) {
            const result = await fetchProgramOutlineService(programId);
            if (result.data) {
                setProgramData(result.data.programData);
                setModulesData(result.data.modulesData);
                setUnitsData(result.data.unitsData);
                // const structuredModules = createModulesFromUnits(result.data.unitsData);
                // setModulesData(structuredModules);
                console.log('programData:', result.data.programData);
                console.log('modulesData:', result.data.modulesData);
                console.log('unitsData:', result.data.unitsData);
            }
        }
        setShowLoader(false);
    };

    const createModulesFromUnits = (units) => {
        const moduleSize = 3;
        const modules = [];

        for (let i = 0; i < units.length; i += moduleSize) {
            modules.push({
                module_name: `Module ${Math.floor(i / moduleSize) + 1}`,
                units: units.slice(i, i + moduleSize).map(unit => ({
                    unit_name: unit.unit_name,
                    unit_id: unit.unit_id,
                    unit_duration: unit.unit_duration,
                    sessions: unit.sessions || [],
                }))
            });
        }
        return modules;
    };
    const data = {
        programData,
        unitsData,
        modulesData,
        chats: chatHistory
    };

    const options = {
        height: '210px',
        chatType: 'programOutline',
        chatPreview: false,
    };

    const actions = {
        goHome: () => {
            history.push('/'); // Redirect to the home page
        },
        goDashboard:()=>{
            history.push(`/program/${programId}/dashboard`);
        },
        registerAndGenerate: () => {
            history.push('/subscribe'); // Redirect to the subscription page
        },
        removeModule: async (programId, moduleId) => {
            setShowLoader(true);
            try {
                const result = await removeModuleProgramService(programId, moduleId);
                if (result && result.data) {
                    setProgramData(result.data.programData);
                    setModulesData(result.data.modulesData);
                }
            } catch (error) {

            }
            setShowLoader(false);
        },
        removeUnit: async (programId, moduleId, unitId) => {
            setShowLoader(true);
            try {
                const result = await removeUnitProgramService(programId, moduleId, unitId);
                if (result && result.data) {
                    setProgramData(result.data.programData);
                    setModulesData(result.data.modulesData);
                    setUnitsData(result.data.unitsData);

                    // const updatedModules = createModulesFromUnits(result.data.unitsData);
                    // setModulesData(updatedModules);
                }
            } catch (error) {

            }
            setShowLoader(false);
        },
        removeSession: (sessionId) => {
            toastWarning('Not Implemented !!')
        },
        sendMessageAction: (message) => {
            setChatHistory((prevChatHistory) => [
                ...prevChatHistory,
                { type: CHAT_TYPE.USER, text: message },
            ]);

            return new Promise((resolve) => {
                setTimeout(() => {
                    let responseData;

                    setChatHistory(async (prevChatHistory) => {
                        const updatedChatHistory = [...prevChatHistory];

                        const chatLength = updatedChatHistory.filter(
                            (msg) => msg.type === CHAT_TYPE.USER
                        ).length;

                        switch (chatLength) {
                            case 1:
                                responseData = {
                                    response_message:
                                        'Sure, I can help you with your program outline.',
                                    programId: 'programId123',
                                }
                                break;
                            case 2:
                                responseData = {
                                    response_message: 'What changes would you like to make?',
                                }
                                break;
                            case 3:
                                responseData = {
                                    response_message:
                                        'Your program outline has been updated!',
                                    programId: 'programId123',
                                };
                                break;
                            case 4:
                            default:
                                responseData = {
                                    response_message: 'Thank you for using our service!',
                                };
                                break;
                        }
                        updatedChatHistory.push({
                            type: CHAT_TYPE.BOT,
                            text: responseData.response_message,
                        });

                        resolve({data: responseData});
                        if (responseData.programId) {
                            setShowLoader(true);
                            await updateProgramStatusService(programId, PBDQ3_PROGRAM_STATE.OUTLINE_GENERATED);
                            setShowLoader(false);
                            history.push(`/program/${programId}/dashboard`);
                        }
                        return updatedChatHistory;
                    });
                }, 200);
            });
        },
    };
    if (showLoader) {
        return <Loader />;
    }

    return (
        <div>
            <ProgramOutlineView
                data={data}
                actions={actions}
                options={options}
            />
        </div>
    );
};

export default ProgramOutlinePage;
